<template>
  <div class="filtro-consulta">
    <form
      ref="form"
      v-formulario-cache
      :name="nomeDoForm"
      novalidate
      @keydown.enter.prevent="pesquisar()"
      @submit.prevent="pesquisar()"
    >
      <slot name="form" />
      <div class="botoes">
        <ToolbarPesquisa
          v-if="!semPesquisa"
          :nome-do-form="nomeDoForm"
          :ordenar-por="ordenarPor"
          :ordenar-nomes="ordenarNomes"
          :botao-exportar="botaoExportar"
          :botao-download="botaoDownload"
          @ordenar="ordenar"
          @exportarCSV="exportarCSV"
          @download="download"
        >
          <slot name="toolbar" />
        </ToolbarPesquisa>
        <button
          v-if="botaoAdicionar"
          id="botaoNovo"
          data-test-id="button-novo"
          type="button"
          name="botaoNovo"
          class="btn btn-primary no-radius botao-novo"
          @click="novo()"
        >
          <span class="fa fa-plus"></span>
          {{ tituloNovo }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ToolbarPesquisa from '@/componentes/ToolbarPesquisa'
import appStore from '@/stores'

export default {
  name: 'BlocoFiltroPesquisa',
  components: { ToolbarPesquisa },
  props: {
    ordenarPor: {
      type: Array,
      default: () => {
        return []
      },
    },
    ordenarNomes: {
      type: Array,
      default: () => {
        return []
      },
    },
    titulo: {
      type: String,
      default: 'Filtro',
    },
    semPesquisa: {
      type: Boolean,
      default: false,
    },
    dados: {
      type: Array,
      default: () => {
        return []
      },
    },
    botaoExportar: {
      type: Boolean,
      default: false,
    },
    botaoDownload: {
      type: Boolean,
      default: false,
    },
    botaoAdicionar: {
      type: Boolean,
      default: true,
    },
    nomeArquivoExportacao: {
      type: String,
      default: 'Exportação-Cardea-',
    },
    header: {
      type: String,
      default: '',
    },
    nomeDoForm: {
      type: String,
      required: true,
    },
  },
  computed: {
    tituloNovo() {
      return appStore.tituloNovo || 'Novo(a)'
    },
  },
  methods: {
    ordenar(prop) {
      this.$emit('ordenar', prop)
    },
    pesquisar() {
      this.$emit('pesquisar')
    },
    exportarCSV() {
      if (this.dados && this.dados.length > 0) {
        let csvContent = 'data:text/csv;charset=utf-8,'
        const items = this.dados
        const replacer = (key, value) => (value === null ? '' : value) // specify how you want to handle null values here
        const colunas = this.header
        const header = colunas.split(';')
        let csv = items.map((row) =>
          header
            .map((fieldName) => JSON.stringify(row[fieldName], replacer))
            .join(',')
        )
        csv.unshift(header.join(','))
        csv = csv.join('\r\n')
        csvContent += csv
        const data = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute(
          'download',
          this.nomeArquivoExportacao + new Date().toISOString() + '.csv'
        )
        link.click()
      }
    },
    download() {
      this.$emit('download')
    },
    novo() {
      this.$emit('novo')
    },
  },
}
</script>

<style scoped>
.filtro-consulta {
  padding: 8px 15px 12px 15px;
  margin: 0;
  background-color: #f9f9f9;
  border: 1px solid #ecf0f1;
  border-radius: 2px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.botoes {
  display: flex;
  justify-content: space-between;
}

.botao-novo {
  height: fit-content;
}
</style>
